import React from 'react'
import { Line } from 'react-chartjs-2'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js'
import { ChartProps } from 'react-chartjs-2/dist/types'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

interface LineChartProps extends ChartProps<'line'> {
  height?: number
}

const LineChart: React.FC<LineChartProps> = (props) => {
  return (
    <Line
      data={props.data}
      options={props.options}
      height={props.height || 150}
    />
  )
}
export default LineChart
